var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/bangbangstudio.ru/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IllustrationComponents/IllustrationItem/IllustrationItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IllustrationComponents/IllustrationItem/IllustrationItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["illustration", "language"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("illustration", Object.prototype.hasOwnProperty.call(kwargs, "illustration") ? kwargs["illustration"] : {});frame.set("language", Object.prototype.hasOwnProperty.call(kwargs, "language") ? kwargs["language"] : "");var t_5 = "";t_5 += "\n    <a href=\"";
if(runtime.contextOrFrameLookup(context, frame, "language") == "en") {
t_5 += "/";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "language"), env.opts.autoescape);
;
}
t_5 += "/illustrations/illustration/";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"id"), env.opts.autoescape);
t_5 += "\"\n       class=\"IllustrationItem";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"illustrationType") == 1) {
t_5 += " small";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"illustrationType") == 2) {
t_5 += " medium";
;
}
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"illustrationType") == 3) {
t_5 += " large";
;
}
t_5 += " isHide\" \n       data-scroll data-scroll-offset=\"60\" data-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"id"), env.opts.autoescape);
t_5 += "\">\n        ";
t_5 += runtime.suppressValue((lineno = 6, colno = 30, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"image2x"), "macros[\"image2x\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"image"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"isGif"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"altText"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n        <div class=\"IllustrationItem-caption\">\n            ";
frame = frame.push();
var t_10 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "token")),"type") != 3?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "illustration")),"tokens"):"");
if(t_10) {t_10 = runtime.fromIterator(t_10);
var t_9 = t_10.length;
for(var t_8=0; t_8 < t_10.length; t_8++) {
var t_11 = t_10[t_8];
frame.set("token", t_11);
frame.set("loop.index", t_8 + 1);
frame.set("loop.index0", t_8);
frame.set("loop.revindex", t_9 - t_8);
frame.set("loop.revindex0", t_9 - t_8 - 1);
frame.set("loop.first", t_8 === 0);
frame.set("loop.last", t_8 === t_9 - 1);
frame.set("loop.length", t_9);
t_5 += "\n                ";
if(runtime.memberLookup((t_11),"type") == 1) {
t_5 += "<p>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_11),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
t_5 += "</p>";
;
}
t_5 += "\n                ";
if(runtime.memberLookup((t_11),"type") == 2 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 1) {
t_5 += "\n                    <span>&nbsp;/&nbsp;</span>\n                    <p>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_11),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
t_5 += "</p>\n                ";
;
}
t_5 += "\n                ";
if(runtime.memberLookup((t_11),"type") == 2 && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") == 0) {
t_5 += "\n                    <p>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_11),"translations")),runtime.contextOrFrameLookup(context, frame, "language"))),"name"), env.opts.autoescape);
t_5 += "</p>\n                ";
;
}
t_5 += "\n                ";
t_5 += "\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n        </div>\n    </a>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("IllustrationItem");
context.setVariable("IllustrationItem", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IllustrationComponents/IllustrationItem/IllustrationItem.jinja"] , dependencies)